import { Callout, IconCalendarEuroRegular, ButtonLink, skinVars, Text1 } from '@telefonica/mistica';
import { AxiosResponse } from 'axios';
import './index.scss';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ISharedProps } from '../../models/interfaces';
import { getDevices } from '../../services/ProductService';
import { getFormatDate } from '../../utils/dataTransformation/dateConversions';
import MobileSections from '../MobileSections';
import OtherServicesSection from '../OtherServicesSection';
import { CardsHome } from '../CardsFlexHome';
import { WarningLine } from '../WarningEsim';
import { Device } from '../../models/Devices';
import { useQuery } from '@tanstack/react-query';
import { getSIMSInfos } from '../../services/ConfigureLineService';
import { useMobileLinesContext } from '../../utils/store/context/mobile-lines-context/MobileLinesContext';
import { useConfigureLineContext } from '../../utils/store/context/configure-line-context/ConfigureLineContext';
import { InfoSIM } from '../../models/ConfigureLine';
import useSimsInfos from '../../utils/hooks/useSimsInfos';

const Convergent: React.FC<ISharedProps> = (dataTab: any) => {
    const { t } = useTranslation();
    const { setOptionShowDataSharing } = useMobileLinesContext();
    const { setIsConvergent } = useConfigureLineContext();
    const [billing] = useState(dataTab.dataTab.cycleEnded);
    const [devices, setDevices] = useState<Device[]>([]);
    const [dataSims, setDataSims] = useState<InfoSIM[]>([]);
    const { simsInfosRequest } = useSimsInfos();

    useEffect(() => {
        simsInfosRequest(setDataSims);
    }, []);

    useEffect(() => {
        setOptionShowDataSharing(dataTab.dataTab?.additionalMobiles?.length > 0);
    }, []);

    useEffect(() => {
        setIsConvergent(true);
    }, []);

    useEffect(() => {
        getDevices().then((response: AxiosResponse) => {
            setDevices(response.data);
        });
    }, []);

    return (
        <div className='convergent-page'>
            <div className='convergent-page__content'>
                <WarningLine warningsInfo={dataSims!} />
                {billing && (
                    <div className='convergent-page__content-callout'>
                        <Callout
                            icon={<IconCalendarEuroRegular />}
                            title={t('consumptionInformation')}
                            description={t('consumptionInformationDescription')}
                            buttonLink={
                                <ButtonLink
                                    onPress={() => {
                                        alert({
                                            title: t('consumptionInformation'),
                                            message: t('alertCycleEndedDescription'),
                                            acceptText: t('buttonUnderstoodFeedback'),
                                            icon: (
                                                <IconCalendarEuroRegular
                                                    size={64}
                                                    color={skinVars.colors.brand}
                                                ></IconCalendarEuroRegular>
                                            ),
                                        });
                                    }}
                                >
                                    {t('moreInformation')}
                                </ButtonLink>
                            }
                        />
                    </div>
                )}
                <div className='convergent-page__content-mobileSections'>
                    <MobileSections dataMobiles={dataTab} sharedData={dataTab.sharedData}></MobileSections>
                </div>
                <div className='convergent-page__content-otherServicesSection-title'>
                    <Text1 medium color={skinVars.colors.textSecondary}>
                        {t('otherServices')}
                    </Text1>
                </div>
                <div className='convergent-page__content-otherServices-cards'>
                    <OtherServicesSection
                        dataTab={dataTab.dataTab.fiber}
                        BillingCycle={`${getFormatDate(dataTab.dataTab.cycleStarts, 'DD/MM')} - ${getFormatDate(
                            dataTab.dataTab.cycleEnds,
                            'DD/MM',
                        )} `}
                        closing={`${dataTab.dataTab.cycleEndInDays} ` + t('day')}
                        devices={devices}
                        netflix={dataTab.dataTab.netflix}
                    ></OtherServicesSection>
                </div>
                <CardsHome product='convergent'></CardsHome>
            </div>
        </div>
    );
};

export default Convergent;
